import * as React from "react"
import type { SVGProps } from "react"
const SvgParagraphIndentFirstLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 21.29a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7q0-.43.29-.72A1 1 0 0 1 4 19.3h16q.42 0 .71.28.3.3.29.72c-.01.42-.1.52-.29.7a1 1 0 0 1-.71.3zm8-4a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7q0-.43.29-.72a1 1 0 0 1 .71-.28h8q.42 0 .71.28.3.3.29.72c-.01.42-.1.52-.29.7a1 1 0 0 1-.71.3zm0-4a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7q0-.43.29-.72a1 1 0 0 1 .71-.28h8q.42 0 .71.28.3.3.29.72c-.01.42-.1.52-.29.7a1 1 0 0 1-.71.3zm0-4a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7q0-.43.29-.72A1 1 0 0 1 12 7.3h8q.42 0 .71.28.3.3.29.72c-.01.42-.1.52-.29.7a1 1 0 0 1-.71.3zm-8-4a1 1 0 0 1-.71-.3A1 1 0 0 1 3 4.3q0-.44.29-.72A1 1 0 0 1 4 3.3h16q.42 0 .71.28.3.3.29.72c-.01.42-.1.52-.29.7a1 1 0 0 1-.71.3zm-.15 10.15q-.25.24-.55.12T3 15.1V9.5q0-.36.3-.48t.55.13l2.8 2.8a.5.5 0 0 1 0 .7z" />
  </svg>
)
export default SvgParagraphIndentFirstLine
